
module.exports = exports = require('./tfdom');

exports.send = function(url, data, callback) {
	if (!callback) callback = data;
	var req = new XMLHttpRequest();
	req.onreadystatechange = function() {
		if (req.readyState == 4 && req.status == 200) {
			callback(req);
		}
	};
	if (arguments.length === 2) {
		req.open('GET', url, true);
		req.send();
	} else if (arguments.length === 3) {
		console.log('Sending post');
		req.open('POST', url, true);
		req.send(data);
	}
};
